﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";

interface IMoneyScope extends ng.IScope {
    currency: string;
}

@NgComponent({
    token: Token.KbMoney,
    dependencies: [
        Token.KbService,
        Token.$RootScope
    ]
})
export class KbMoney extends Directive {
    constructor(
        private kbService: KbService,
        private $rootScope
    ) {
        super();
        this.template = '<input class="kb-textbox" type="text" />';

        this.restrict = "E";
        this.scope = {
            label: "@",
            ngModel: "=",
            currency: "@"
        };
        this.require = "?ngModel";
        this.replace = true;
        this.transclude = true;

        this.link = (
            scope: IMoneyScope,
            element: ng.IAugmentedJQuery,
            atts: ng.IAttributes,
            ngModel: ng.INgModelController
        ) => {

            let update = v => {
                return v ?
                    kbService.fxConvert(
                        parseFloat(v),
                        this.$rootScope.companySettings.currency.toUpperCase(), scope.currency)
                    : 0;
            };

            scope.$watch("currency", () => {
                ngModel.$modelValue = (update(ngModel.$viewValue));
            });

            ngModel.$formatters.push(v => v ? kbService.fxConvert(parseFloat(v), scope.currency) : 0);
            ngModel.$parsers.push(update);
        };
    }
}
